import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Pages/Home";
// import Courses from "./pages/Courses";
// import Destinations from "./pages/Destinations";
import ContactSection from './Components/ContactSection';
import Footer from './Components/Footer';
import ABout from "./Pages/ABout";
import "./App.css"; // Importing the main CSS file
import Careers from "./Pages/Careers";
import Services from "./Pages/Services";
import DynamicPage from "./Pages/DynamicPage";
import Testprep from "./Pages/Testprep";
import Contact from "./Pages/Contact";
import ScrollToTop from './Components/ScrollToTop';
import MetaTags from "./Pages/MetaTags";
import PrivacyPolicy from './Pages/Privacy';
import TermsConditions from './Pages/Terms';
import Blogs from "./Pages/Blogs";
import Blogdetail from "./Pages/Blogdetail";

function App() {
  return (
    <>
   
      <Header />
      <ScrollToTop/>
       <MetaTags />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/courses" element={<Courses />} />
        <Route path="/destinations" element={<Destinations />} />*/}
        <Route path="/services" element={<Services />} />
        <Route path="/services/university-country-course-selection" element={<Services />} />
        <Route path="/services/career-counselling-and-profile-evaluation" element={<Services />} />
        <Route path="/services/test-preparation" element={<Services />} />
        <Route path="/services/application-submission" element={<Services />} />
        <Route path="/services/application-and-admission-assistance" element={<Services />} />
        <Route path="/services/visa-counseling" element={<Services />} />
        <Route path="/services/pre-departure-briefing" element={<Services />} />
        <Route path="/services/post-arrival-assistance-and-services" element={<Services />} />
        <Route path="/services/assistance-in-accommodation" element={<Services />} />
        <Route path="/services/education-loan-assistance" element={<Services />} />
        <Route path="/services/flight-ticket-booking-forex-and-insurance" element={<Services />} />
         <Route path="/destinations/:id" element={<DynamicPage />} />
        <Route path="/courses" element={<Testprep />} /> 
        <Route path="/about" element={<ABout />} /> 
        <Route path="/careers" element={<Careers />} /> 
          <Route path="/Blogs" element={<Blogs />} />
          <Route path="/blog-details" element={<Blogdetail />} />
        <Route path="/Contact" element={<Contact />} /> 
         <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
          <Route path="/terms-and-conditions" element={<TermsConditions />} /> 
      </Routes>
      <ContactSection/>
      <Footer/>
    </>
  );
}

export default App;
